import { ascend, sortWith } from 'ramda'

import { PHASE_TYPES } from '~/src/Harvest/constants'
import createEntityBundle, { createCustomAction, getActionType } from '~/src/Lib/createEntityBundle'
import createLogger from '~/src/Lib/Logging'
import { EMPTY_OBJECT } from '~/src/Lib/Utils'
import { Recipe as schema } from '~/src/Store/Schemas'

const name = 'recipes'
const singularName = 'recipe'
const defaultConfig = { name, singularName, schema }

const logger = createLogger('Recipe/bundle')

const sortPhases = sortWith([
  ascend(phase => PHASE_TYPES.indexOf(phase.phaseType)),
  ascend(phase => phase.sequence || 0),
])

const {
  actionIdentifiers: saveAsRecipe,
  actionReducer: saveAsRecipeReducer,
  defaultState: defaultSaveAsRecipeState,
} = createCustomAction({
  actionType: 'save',
  actionName: 'as_recipe',
  reducerKey: 'saveas',
  loadingKey: 'saving',
})

const initialBundle = createEntityBundle({
  ...defaultConfig,
  apiConfig: { schema },
  scope: {
    selector: 'selectCurrentFacility',
    test: (currentFacility, recipe) =>
      currentFacility &&
      recipe &&
      (recipe.organizationId === currentFacility.organization || recipe.facilityId === currentFacility.id),
  },
})

const {
  reducer: entityReducer,
  doRecipeSave: { createSnackbarAction },
} = initialBundle

const initialState = {
  ...entityReducer.defaultState,
  ...defaultSaveAsRecipeState,
}

export default {
  ...initialBundle,
  reducer: (state = initialState, action = EMPTY_OBJECT) => {
    if (action.type && action.type.startsWith(saveAsRecipe.types.prefix)) {
      return saveAsRecipeReducer(state, action)
    }
    return entityReducer(state, action)
  },
  doRecipeSaveAs:
    payload =>
    async ({ dispatch, store, apiFetch }) => {
      dispatch({ type: saveAsRecipe.types.start })
      let result
      try {
        result = await apiFetch('/recipes/from_harvest/', payload, { method: 'POST' })
        dispatch({ type: saveAsRecipe.types.succeed, payload: result })
        createSnackbarAction({ dispatch, status: 'succeed', payload: result })
        store.doMarkRecipeListAsOutdated()
      } catch (error) {
        result = error
        dispatch({ type: saveAsRecipe.types.fail, error })
        createSnackbarAction({ dispatch, status: 'fail', payload })
      }
      return result
    },
  doRecipeCopy:
    payload =>
    async ({ store }) => {
      let result
      try {
        const apiPayload = {
          ...payload,
          phases: sortPhases(payload.phases).map((phase, index) => ({
            ...phase,
            sequence: index,
            tasks: phase.tasks.map(t => ({
              ...t,
              id: undefined,
            })),
          })),
        }

        result = await store.doRecipeSave(apiPayload)
        if (result && result.id) {
          store.doMarkRecipeListAsOutdated()
        }
      } catch (error) {
        result = error
      }
      return result
    },
  persistActions: [getActionType('update', name)],
}
